import {render, createElement, useState, useEffect} from '@wordpress/element';
import Modal from './components/Modal.jsx';
import ServiceList from './components/ServiceList.js';
import './modal.css';

const App = () => {
    const [open, setOpen] = useState(false);
    const [taxonomy, setTaxonomy] = useState(null);
    const [rankingId, setRankingId] = useState(null);
    const [selectedTerms, setSelectedTerms] = useState([]);

    //React зчитує список колонок з DOM
    const [columnsOpen, setColumnsOpen] = useState(false);
    const [columns, setColumns] = useState([]);
    const [visibleColumns, setVisibleColumns] = useState([]);
// Ефект для мобільного сортування
    useEffect(() => {
        const mobSortBtn = document.querySelector('.mobile-sort .mobile-sort-opener');
        if (!mobSortBtn) return;

        const handleMobSort = (e) => {
            e.preventDefault();

            // Знаходимо першу колонку, яка зараз позначена як видима
            // (в мобільній версії це зазвичай та, що вибрана користувачем)
            if (visibleColumns.length > 0) {
                const activeColId = visibleColumns[1];
                // Якщо у вас логіка мобільної версії відображає лише ОДНУ колонку,
                // то вона буде першою в масиві visibleColumns.
                sortByColumn(activeColId);
            }
        };

        mobSortBtn.addEventListener('click', handleMobSort);
        return () => mobSortBtn.removeEventListener('click', handleMobSort);
    }, [visibleColumns]); // Перепідписуємось, якщо список видимих колонок змінився
    useEffect(() => {
        const ths = document.querySelectorAll('.company-table th[data-col]');
        const cols = [...ths].map(th => ({
            id: th.dataset.col,
            label: th.innerText.trim()
        }));

        setColumns(cols);
        setVisibleColumns(cols.map(c => c.id)); // всі видимі за замовчуванням
    }, []);

    useEffect(() => {
        const btn = document.querySelector('.company-table__settings a');

        if (!btn) return;

        btn.addEventListener('click', (e) => {
            e.preventDefault();
            setColumnsOpen(true);

        });
    }, []);
    const applyColumnsVisibility = () => {
        const all = document.querySelectorAll('.company-table [data-col]');

        all.forEach(el => {
            const id = el.dataset.col;
            el.style.display = visibleColumns.includes(id) ? '' : 'none';
        });
    };
    //==================================================================================================================
    // JS‑сортування Вішаємо клік на заголовки таблиці / клік по заголовку колонки → сортування таблиці
    useEffect(() => {
        const headers = document.querySelectorAll('.company-table th[data-col] a');

        const handler = (e) => {
            e.preventDefault();
            const th = e.currentTarget.closest('th');
            const colId = th.dataset.col;
            sortByColumn(colId);
        };

        headers.forEach(h => h.addEventListener('click', handler));

        return () => headers.forEach(h => h.removeEventListener('click', handler));
    }, []);

    useEffect(() => {
        initScrollbars();
    }, []);

    const onClick = (e) => {
        e.preventDefault();
        const el = e.currentTarget;
        setTaxonomy(el.dataset.field);     // service / city / industry
        setRankingId(el.dataset.ranking);  // ID ренкінгу
        setOpen(true);
    };

    useEffect(() => {
        const elements = document.querySelectorAll('.company-table__filter-item .opener, .company-table__header .opener');
        elements.forEach(el => el.addEventListener('click', onClick));
        return () => {
            elements.forEach(el => el.removeEventListener('click', onClick));
        };
    }, []);

    const applyFilter = (selected) => {
        setSelectedTerms(selected); // ← ЗБЕРЕГЛИ ВИБІР

        const formData = new FormData();
        formData.append('action', 'filter_ranking');
        formData.append('taxonomy', taxonomy);
        formData.append('ranking_id', rankingId);

        selected.forEach(id => {
            formData.append('terms[]', id); // ← ВАЖЛИВО
        });


        fetch(pacers.ajaxUrl, {
            method: 'POST',
            body: formData
        })
            .then(res => res.json())
            .then(res => {
                if (res.success) {
                    document.querySelector('.company-table__frame').innerHTML = res.data.html;
                    // Ініціалізуємо скрол
                    initScrollbars();
                    applyColumnsVisibility();
                    const headers = document.querySelectorAll('.company-table th[data-col] a');
                    headers.forEach(h => {
                        h.addEventListener('click', (e) => {
                            e.preventDefault();
                            const th = e.currentTarget.closest('th');
                            const colId = th.dataset.col;
                            sortByColumn(colId);
                        });
                    });

                }
            });

        setOpen(false);
    };

    return (
        <>
            {open && (
                <Modal onClose={() => setOpen(false)}>
                    <h3>Services</h3>
                    <ServiceList
                        taxonomy={taxonomy}
                        rankingId={rankingId}
                        selectedTerms={selectedTerms}
                        setSelectedTerms={setSelectedTerms}
                        onApply={applyFilter}/>
                    {/* Попап Customize Columns */}

                </Modal>
            )}
            {columnsOpen && (
                <ColumnsPopup
                    columns={columns}
                    visibleColumns={visibleColumns}
                    setVisibleColumns={setVisibleColumns}
                    onApply={() => {
                        applyColumnsVisibility();
                        setColumnsOpen(false);
                    }}
                />
            )}
        </>
    );
};

document.addEventListener('DOMContentLoaded', () => {
    const el = document.createElement('div');
    document.body.appendChild(el);
    render(<App/>, el);
});

const initScrollbars = () => {
    const scroll = document.querySelector('.company-table .scroll');
    const external = document.querySelector('.company-table .external-scroll_x');

    if (!scroll || !external) return;

    // виставляємо ширину "контенту" для нижнього скролу
    const sizeEl = external.querySelector('.scroll-element_size');
    if (sizeEl) {
        sizeEl.style.width = scroll.scrollWidth + 'px';
    }

    const syncToExternal = () => {
        external.scrollLeft = scroll.scrollLeft;
    };

    const syncToScroll = () => {
        scroll.scrollLeft = external.scrollLeft;
    };

    // щоб не навішувати дублікати — спочатку знімаємо
    scroll.removeEventListener('scroll', syncToExternal);
    external.removeEventListener('scroll', syncToScroll);

    scroll.addEventListener('scroll', syncToExternal);
    external.addEventListener('scroll', syncToScroll);
};

function ColumnsPopup({columns, visibleColumns, setVisibleColumns, onApply}) {

    const toggle = (id) => {
        if (visibleColumns.includes(id)) {
            setVisibleColumns(visibleColumns.filter(c => c !== id));
        } else {
            setVisibleColumns([...visibleColumns, id]);
        }
    };

    return (
        <div className="columns-popup">
            <div className="columns-popup__inner">
                <h3>Customize columns</h3>

                <ul>
                    {columns.map(col => (
                        <li key={col.id}>
                            <label>
                                <input
                                    type="checkbox"
                                    checked={visibleColumns.includes(col.id)}
                                    onChange={() => toggle(col.id)}
                                />
                                {col.label}
                            </label>
                        </li>
                    ))}
                </ul>

                <button className="btn btn-blue" onClick={onApply}>Apply</button>
            </div>
            <button className="close-btn" onClick={() => setColumnsOpen(false)}>×</button>
        </div>
    );
}

const sortByColumn = (colId) => {
    const leftTable = document.querySelector('.company-table .name-col table tbody');
    const rightTable = document.querySelector('.company-table .data-col table tbody');

    if (!leftTable || !rightTable) return;

    const leftRows = Array.from(leftTable.querySelectorAll('tr'));
    const rightRows = Array.from(rightTable.querySelectorAll('tr'));

    // визначаємо напрямок
    const current = document.querySelector(`th[data-col="${colId}"]`);
    const asc = !current.classList.contains('sort-asc');

    document.querySelectorAll('.company-table th').forEach(th => {
        th.classList.remove('sort-asc', 'sort-desc');
    });
    current.classList.add(asc ? 'sort-asc' : 'sort-desc');

    // створюємо масив об’єктів {leftRow, rightRow, value}
    const combined = leftRows.map((row, index) => {
        let value;

        if (colId === 'name') {
            value = row.querySelector('a')?.innerText.trim() || '';
        } else {
            value = rightRows[index].querySelector(`td[data-col="${colId}"]`)?.innerText.trim() || '';
        }

        return {
            left: row,
            right: rightRows[index],
            value
        };
    });

    // визначаємо чи це число
    const isNumber = combined.every(item => !isNaN(parseFloat(item.value)));

    combined.sort((a, b) => {
        if (isNumber) {
            return asc
                ? parseFloat(a.value) - parseFloat(b.value)
                : parseFloat(b.value) - parseFloat(a.value);
        }
        return asc
            ? a.value.localeCompare(b.value)
            : b.value.localeCompare(a.value);
    });
    const mobSortIcon = document.querySelector('.mobile-sort-opener i');
    if (mobSortIcon) {
        if (asc) {
            // Сортування від меншого до більшого (A-Z)
            mobSortIcon.classList.remove('fa-sort-amount-down');
            mobSortIcon.classList.add('fa-sort-amount-up');
        } else {
            // Сортування від більшого до меншого (Z-A)

            mobSortIcon.classList.remove('fa-sort-amount-up');
            mobSortIcon.classList.add('fa-sort-amount-down');
        }
    }
    // вставляємо назад у правильному порядку
    combined.forEach(item => {
        leftTable.appendChild(item.left);
        rightTable.appendChild(item.right);
    });

};